/**
 * Designed by Junhua on 17/2/16.
 */
import axios from '../http'
import Qs from 'qs'
import vm from '../main'

let urls = {
    login:'login/gzh',    //登陆
    consume:'orders/consume',//核销
    getJssdk:'wxMsg/getjssdk',
    getAllOrder:'orders/getall',
    getOrderList:'orders/getlist',
    getToUseSummary:'orders/toUseList',
    getToUseTotal:'orders/toUseTotal',
    getSceneQr:'wxLogin/sceneQr',
    getActById:'activity/getone',
    helpFreeMeal:'activity/freeMeal/help',
    checkOpenId:'login/activity/check',
    getPayParam:'pay/gzh',
    getTotalSale:'home/totalSale',
    getDailySale:'home/dailySale',
    getActiveHome:'home/getActive',
    getDictByType:'dict/getallbytype',

    getShopDet:'shop/getone',
    getAllGoods:'goods/getall',
    getGoodsList:'goods/getlist',
    getGoodsDet:'goods/getone',
    getGoodsSaledQty:'goods/getSaledQty',
    submitOrder:'orders',
    getOrderDet:'orders/getone',
    paidOrder:'orders/paid',

    getAllLabel:'label/getall',

    getCollectionList:'collection/getlist',
    checkCollect:'collection/getone',
    saveCollection:'collection/save',
    deleteCollection:'collection/remove',
    getAllCollection:'collection/getall',

    submitFreeMeal:'activity/freeMeal/submit',
    getAllAct:'activity/getall',
    getAllShop:'shop/getall',
    helpCutPrice:'activity/cutPrice/help',
    refund:'orders/refund',
    cancelRefund:'orders/refund/cancel',

    getAllCoupon:'coupon/getall',
    getCouponList:'coupon/getlist',
    submitCoupon:'coupon/submit',
    paidCoupon:'coupon/paid',

    getAllCouponOrder:'coupon/order/getall',
    getCouponOrderList:'coupon/order/getlist',

    prepayOrder:'orders/prepay',

    getVeriCode:'sms',
    verifyCode:'sms/verify',
    getCusById:'customer/getone',
    updateCus:'customer/update',

    getSearchList:'home/search',
    getMyAct:'activity/mine',

    getTime:'time',

    getInviteList:'activity/inviteList',



}

//包装get
let getMethod = (url,query) => axios.get(url + '?' + Qs.stringify(query))

let postMethod = (url,query) => axios.post(url , query)//包装post

let post = async function(reqUrl,query,selfHandle){
    console.log(reqUrl)
    if('login'.indexOf(reqUrl) == -1 && localStorage.token){//登录api不需要检查token
        if(query){
            query.token = localStorage.token;
        }else{
            query = {
                token : localStorage.token
            }
        }
    }
    let res = null;
    try{//捕捉请求异常并提示错误
        res = await postMethod(urls[reqUrl],query);
    }catch(e){
        vm.$toast.fail('远程服务器失联了，请检查您的网络！');
        return null;
    }
    if(res.data.code == '400' && 'login'.indexOf(reqUrl) == -1){//token失效
        vm.$toast.fail( '身份认证已过期,正在重新登录！');
        localStorage.clear();
        location.href = `${window.config.baseURL}wxLogin?path=${window.entryUrl}`
        return null;
    }else if(res.data.code != '0'){//其他错误
        if(selfHandle){
            return res;
        }else {
            vm.$toast.fail(res.data.msg);
            return null;
        }
    }
    else{//正常的情况
        return res;
    }
};


let get = async function(reqUrl,query,selfHandle){
    if(query) query.v = 1;
    else query = { v : 1};
    if(reqUrl != 'login' && localStorage.token){//登录api不需要检查token
        if(query){
            query.token = localStorage.token;
        }else{
            query = {
                token : localStorage.token
            }
        }
    }
    let res = null;
    try{//捕捉请求异常并提示错误
        res = await getMethod(urls[reqUrl],query);
    }catch(e){
        vm.$toast.fail('远程服务器失联了，请检查您的网络！');
        return null;
    }
    if(res.data.code == '400' && 'login'.indexOf(reqUrl) == -1){//token失效
        vm.$toast.fail('身份认证已过期,正在重新登录！');
        localStorage.removeItem('token');
        console.log('mohter fucker。。。。。。。。。。')
        console.log(`${window.config.baseURL}wxLogin?path=${window.entryUrl}`)
        // location.href = `${window.config.baseURL}/wxLogin?path=${window.entryUrl}`
        return null;
    }else if(res.data.status.code != '0'){//其他错误
        if(selfHandle){
            return res;
        }else {
            vm.$toast.fail(res.data.msg);
            return null;
        }
    }else{//正常的情况
        return res;
    }
}

export default {
    get:get,
    post:post,
    url:axios.defaults.baseURL,
}